import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import ProceedButton from '../Multiple/ProceedButton';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBenefitDetails,setvehiclePlanId } from '../../store/reducers/benefitReducer';
import Spinner from './../Spinner';

import './MemberShip.css';

const features = [
  { title: 'Number of Services', detail: '4' },
  { title: 'Towing', detail: 'Radius of 50 KMs from where the vehicle is immobilised' },
  { title: 'Accident cover-Towing', detail: 'Radius of 50 KMs from where the vehicle is immobilised' },
  { title: 'Wrong fuelling-towing', detail: 'PAN India' },
  { title: 'On-site minor repairs', detail: 'PAN India' },
  { title: 'Tyre Problem or Tyre change', detail: 'PAN India' },
  { title: 'Battery Jump Start', detail: 'PAN India' },
  { title: 'Locked / key lost', detail: 'PAN India' },
  { title: 'Battery Jump Start', detail: 'PAN India' },
  { title: 'Taxi Arrangement', detail: 'Yes' },
  { title: 'Ambulance Referral', detail: 'Yes' },
];

const MembershipFeatures = () => {
    const dispatch = useDispatch();
    const benefitListState = useSelector((state) => state.benefitList || {}); // From Reducers
    const { apiResponse, loading, apiErrorMsg } = benefitListState;
    const benefitListData = apiResponse?.data ?? [];
    const location = useLocation();
    const PlanId = location?.state?.data?.plan_id;

    console.log("PlanId from location:", PlanId);
    const vehiclePlanId = benefitListState?.vehiclePlanId;

    const proceedAmt = location?.state?.data?.amount;
    const planName = location?.state?.data?.plan_description;
    console.log("benefitListData",PlanId);

    useEffect(() => {
        if (PlanId) {
          dispatch(setvehiclePlanId(vehiclePlanId));
          console.log("Dispatching fetchBenefitDetails with PlanId:", vehiclePlanId);
          dispatch(fetchBenefitDetails(PlanId));
        }
      }, [dispatch, PlanId]);
      

     if (loading) {
        return (
            <Spinner />
          );
     }
     console.log("Dispatching vehicleTypeId setvehiclePlanId PlanId:", vehiclePlanId);
     console.log("vehiclePlanId:", vehiclePlanId);
     console.log("PlanId:", PlanId);
  return (
    <div className='membership'>
        <div className='member-title'>
            <img src='/assets/membership.png' alt="Membership" className="membership-icon" />
            <h4>Plan Features</h4>
        </div>
        <div className="membership-wrapper">
            <div className='member-points'>
                <h2>{planName}</h2>
                <div className="feature-group">
                    {benefitListData.map((item, index) => (
                    <div key={index} className="feature-item">
                        <strong><span>{item.benefit_key}</span></strong>
                        <span>{item.benefit_value == 'Yes' ? <span className='item-yes'>
                        <img src='/assets/tick.svg' alt="Tick" className="tick-icon" />
                        {item.benefit_value}</span> : item.benefit_value}</span>
                    </div>
                    ))}
                </div>
            </div>
        </div>
        <ProceedButton amount={proceedAmt} />
    </div>
  );
};

export default MembershipFeatures;
